import { render, staticRenderFns } from "./ToutiaoProject.vue?vue&type=template&id=55ba16e6"
import script from "./ToutiaoProject.vue?vue&type=script&lang=js"
export * from "./ToutiaoProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports